import React from "react";
import { defineMessages, injectIntl } from "react-intl";
import styled, { withTheme } from "styled-components/native";
import { localize } from "cci-utility";
import { Container } from "./common";
import Icon from "../icon/FontAwesomePro";

const Text = styled.Text`
  font-size: ${props =>
    props.theme.widePlaceholderFontSize || 20}px;
  font-weight: 200;
  letter-spacing: 1px;
  color: ${props =>
    props.theme.widePlaceholderFontColor || "rgb(167, 167, 167)"};
`;

/**
 * Placeholder which shows a message and a chevron pointing left.
 * 
 * Props:
 * - message: Localization object or string that will be shown to the right of the chevron.
 */
const WidePlaceholder = ({ intl, theme, message }) => (
  <Container
    flexDirection="row"
    alignItems="center"
    justifyContent="center"
    flex={1}
    margins={theme.widePlaceholderMargins}
  >
    <Icon
      style={{
        marginTop: 2,
        marginRight: 20,
        color: theme.widePlaceholderFontColor || "rgb(167, 167, 167)"
      }}
      name="angle-left"
      iconSize={theme.widePlaceholderIconSize || 28}
    />

    <Text>{localize(intl, message)}</Text>
  </Container>
);

export default withTheme(injectIntl(WidePlaceholder));
